export const WA_NUMBER = "628985354000";
export const WA_DISPLAY = "0898-5354-000";
export const ADMIN_URL = "https://billing-dashboard-119.preview.emergentagent.com/";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const PACKAGES = [
  {
    id: "fasnet-10",
    name: "Starter 10",
    speed: 10,
    price: "150.000",
    tagline: "Rumah tangga santai & sosmed",
    ideal: "1–3 perangkat",
    badge: "Hemat & Stabil",
    popular: false,
    color: "#2563EB",
    glow: "rgba(37,99,235,0.5)",
    textOn: "#FFFFFF",
    image: "/images/product-10.png",
    features: [
      "Kecepatan simetris hingga 10 Mbps",
      "Unlimited tanpa batas kuota FUP",
      "Gratis biaya pemasangan (Rp 0)",
      "Termasuk ONT Wi-Fi dual-band",
      "Dukungan teknis lokal Kalbar 24/7",
    ],
  },
  {
    id: "fasnet-20",
    name: "Family 20",
    speed: 20,
    price: "250.000",
    tagline: "Streaming 4K & WFH mulus",
    ideal: "4–7 perangkat aktif",
    badge: "Paling Populer",
    popular: true,
    color: "#F04E23",
    glow: "rgba(240,78,35,0.5)",
    textOn: "#FFFFFF",
    image: "/images/product-20.png",
    features: [
      "Kecepatan simetris hingga 20 Mbps",
      "Unlimited tanpa batas kuota FUP",
      "Gratis biaya pemasangan (Rp 0)",
      "Low ping gaming & bebas buffering",
      "Prioritas pemeliharaan jaringan",
      "Router Wi-Fi fiber high-gain",
    ],
  },
  {
    id: "fasnet-50",
    name: "Turbo 50",
    speed: 50,
    price: "350.000",
    tagline: "Gamer, kreator & usaha",
    ideal: "8+ perangkat & smart home",
    badge: "Ultra Speed",
    popular: false,
    color: "#00E5FF",
    glow: "rgba(0,229,255,0.5)",
    textOn: "#050914",
    image: "/images/product-50.png",
    features: [
      "Kecepatan simetris hingga 50 Mbps",
      "Unlimited tanpa batas kuota FUP",
      "Gratis biaya pemasangan (Rp 0)",
      "Ultra low latency direct peering",
      "Dedicated bandwidth & CS prioritas",
      "Router gigabit wireless premium",
    ],
  },
];
